import { z } from "zod";

export const webPushUriTypeSchema = z.enum(["URI", "NONE", "DEEP_LINK", "CLOSE"]);
